import { forwardRef, type Ref, type SVGProps } from "react";
const IconSignatureFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.135 5.171c.372 1.487.02 3.136-.88 4.787-1.049 1.922-3.07 3.356-4.979 4.377l.053.816.047.74q.633-.257 1.215-.484h.001l.665-.264c.95-.38 2.766-.725 4.046.652.65-.812 1.367-1.604 2.088-2.084.42-.28 1.226-.72 2.215-.538 1.137.209 1.73 1.066 2 1.7.264.62.373 1.344.42 2.06q.07 1.121-.03 2.692a2 2 0 0 1-3.992-.25q.02-.305.03-.578c-.64.84-1.341 1.843-2.101 2.93l-.294.42a2 2 0 0 1-3.58-1.632c.162-.647.235-1.134.257-1.489l-.242.096a48 48 0 0 0-2.543 1.062v.063c-.015 1.272-.108 2.6-.426 3.753H28a2 2 0 1 1 0 4H14.869a7.2 7.2 0 0 1-1.67 1.355c-1.473.854-3.226 1.055-4.686.293A3.8 3.8 0 0 1 6.868 28H4a2 2 0 1 1 0-4h2.895c.528-1.215 1.49-2.407 2.813-3.527a27 27 0 0 1 3.768-2.681q-.04-.851-.098-1.748a32 32 0 0 1-2.893.896 2 2 0 0 1-.97-3.88 29 29 0 0 0 3.617-1.204c-.02-.52-.034-1.03-.038-1.521-.01-1.554.078-3.177.508-4.468 1.07-3.21 4.158-4.655 6.742-3.756a4.3 4.3 0 0 1 2.791 3.06m-9.992 18.086a9 9 0 0 1-.337.743h-1.038q.236-.228.524-.473.516-.436 1.013-.814a3.6 3.6 0 0 1-.162.544m3.953-13.51c.017-1.206.12-2.074.3-2.615.43-1.289 1.343-1.344 1.634-1.243.122.042.187.104.224.252.05.2.09.801-.51 1.901-.308.564-.88 1.142-1.648 1.706m10.549 7.271q0 .002-.027.015z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M6.7 21.889c.4-.4.4-1 0-1.4l-.8-.8.8-.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-.8.8-.8-.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l.8.8-.8.8c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3l.8-.8.8.8c.2.2.5.3.7.3s.5-.1.7-.3"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSignatureFilledSVG);
ForwardRef.displayName = "IconSignatureFilled";
export { ForwardRef as IconSignatureFilled };
